export class LocalStorageHandler {
  constructor() {
    const appInstance = process.env.VUE_APP_APPLICATION_INSTANCE;
    const projectName = "jandepecunia";

    this.appInstance = appInstance;
    this.projectName = projectName;

    this.accessTknKey = "accessToken";
    this.accessTknExpKey = "accessTokenExp";
    this.refreshTknExpKey = "refreshTokenExp";

    this.validKeys = [
      this.accessTknKey,
      this.accessTknExpKey,
      this.refreshTknExpKey,
    ];
  }

  _storeVar(key, value) {
    // Throw error if key is not valid
    if (!this.validKeys.includes(key)) {
      throw new Error(`Invalid key for LocalStorageHandler: ${key}.`);
    }

    localStorage.setItem(
      `${this.appInstance}_${this.projectName}_${key}`,
      value
    );
  }

  _removeVar(key) {
    // Throw error if key is not valid
    if (!this.validKeys.includes(key)) {
      throw new Error(`Invalid key for LocalStorageHandler: ${key}.`);
    }

    localStorage.removeItem(`${this.appInstance}_${this.projectName}_${key}`);
  }

  _getVar(key) {
    // Throw error if key is not valid
    if (!this.validKeys.includes(key)) {
      throw new Error(`Invalid key for LocalStorageHandler: ${key}.`);
    }

    return localStorage.getItem(
      `${this.appInstance}_${this.projectName}_${key}`
    );
  }

  resetLocalStorage() {
    this.validKeys.forEach((key) => {
      this._removeVar(key);
    });
  }

  // region AccessTkn
  storeAccessToken(token) {
    this._storeVar(this.accessTknKey, token);
  }

  removeAccessToken() {
    this._removeVar(this.accessTknKey);
  }

  getAccessToken() {
    const accessToken = this._getVar(this.accessTknKey);

    if (!accessToken) {
      console.error("Access token not found in local storage.");
      return null;
    }

    return accessToken;
  }
  // endregion

  // region AccessTknExp
  storeAccessTokenExpTimestamp(expTimestamp) {
    this._storeVar(this.accessTknExpKey, expTimestamp);
  }

  removeAccessTokenExpTimestamp() {
    this._removeVar(this.accessTknExpKey);
  }

  getAccessTokenExpTimestamp() {
    const expTimestampStr = this._getVar(this.accessTknExpKey);

    if (!expTimestampStr) {
      console.error(
        "Access token expiration timestamp not found in local storage."
      );
      return null;
    }

    return parseInt(expTimestampStr, 10);
  }
  // endregion

  // region RefreshTknExp
  storeRefreshTokenExpTimestamp(expTimestamp) {
    this._storeVar(this.refreshTknExpKey, expTimestamp);
  }

  removeRefreshTokenExpTimestamp() {
    this._removeVar(this.refreshTknExpKey);
  }

  getRefreshTokenExpTimestamp() {
    const expTimestampStr = this._getVar(this.refreshTknExpKey);

    if (!expTimestampStr) {
      console.error(
        "Refresh token expiration timestamp not found in local storage."
      );
      return null;
    }

    return parseInt(expTimestampStr, 10);
  }
  // endregion
}
